import $ from "jquery";

(function($, window, document) {

    "use strict";

    var TLS_Header = function () {
        var self = this;
		var that = this;

    
        this.init_header = function(){
            if($('header.main-header').has('.banner-message')){
                $('main.main-section').addClass('header-has-banner');
                $('header.main-header').addClass('has-banner');
            }
        }
        this.bind = function () {
            $( document ).ready( self.init_header );
            $(window).scroll(function () {
                if ($(this).scrollTop() >= 53) {
                    $(".main-header").addClass("main-header-scrolled");
                } else {
                    $(".main-header").removeClass("main-header-scrolled");
                }
            });	

            $(document).on('yith-wcan-ajax-filtered', function(){
                //alert('yith-wcan-ajax-filtered');
                self.init_header();
            })
        };

        
        this.init = function () {
                
            self.bind();
        };
        
        this.init();

	};

	(new TLS_Header());

}(window.jQuery, window, document));